export default "__VITE_ASSET__DSt709Tb__"